import Regiao from '../../spa/regiao/RegiaoCadastro';

export default {
  path: 'regiao',
  name: 'regiao',
  component: Regiao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/regiao.js